/**
 * Google Tag Manager loader
 *
 * Injects the GTM script and noscript fallback into the document on demand.
 * This is called by `CookieConsentContext` only after the visitor accepts
 * cookies, ensuring GTM never loads without consent.
 *
 * The function is idempotent — repeated calls are safe and do nothing if GTM
 * is already present on the page.
 *
 */
export function loadGTM() {
  if (typeof window === 'undefined') return;

  // Guard against double-injection (e.g. React strict mode double-invocation)
  if (window.dataLayer && document.querySelector('script[src*="gtm.js"]')) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  // Main GTM script tag
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${process.env.NEXT_PUBLIC_GTM_ID}`;
  document.head.appendChild(script);

  // Noscript iframe fallback for environments where JS is disabled
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GTM_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}
